import RsaRiepiloghi from "../index";

const routes = [
    {
        name: "RsaRiepiloghi",
        path: "/rsariepiloghi",
        component: RsaRiepiloghi.RsaRiepiloghiPage,
        meta: { title: " Riepiloghi" },
    },
    {
        name: "RsaRiepilogoVociDiarioList",
        path: "/riepilogovocidiario",
        component: RsaRiepiloghi.RsaRiepilogoVociDiarioListPage,
        meta: { title: " Riepilogo Voci Diario" },
    },
];

export default routes;
